import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", null, "My Page", -1)
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: "https://raw.githubusercontent.com/webistomin/vue-socials/main/assets/icons/twitter.svg",
  class: "w-8 m-auto mt-2"
}, null, -1)
const _hoisted_4 = { class: "mt-6 mx-4 px-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DisplayMyInfo = _resolveComponent("DisplayMyInfo")!
  const _component_EditMyInfo = _resolveComponent("EditMyInfo")!
  const _component_s_twitter = _resolveComponent("s-twitter")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_MyLensList = _resolveComponent("MyLensList")!
  const _component_FocalLength = _resolveComponent("FocalLength")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      (!_ctx.editMode)
        ? (_openBlock(), _createBlock(_component_DisplayMyInfo, {
            key: 0,
            modelValue: _ctx.editMode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.editMode) = $event)),
            dbUser: _ctx.dbUser
          }, null, 8, ["modelValue", "dbUser"]))
        : _createCommentVNode("", true),
      (_ctx.editMode)
        ? (_openBlock(), _createBlock(_component_EditMyInfo, {
            key: 1,
            modelValue: _ctx.editMode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.editMode) = $event))
          }, null, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_s_twitter, {
        "share-options": {
                      url: 'https://lensfolio.net/users/' + _ctx.user.uid,
                      text: 'lensfolio',
                      via: 'lensfolio',
                      }
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["share-options"])
    ]),
    _createVNode(_component_Tab, {
      tabs: _ctx.tabs,
      modelValue: _ctx.selectedTab,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedTab) = $event))
    }, null, 8, ["tabs", "modelValue"]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.selectedTab === 'list')
        ? (_openBlock(), _createBlock(_component_MyLensList, {
            key: 0,
            lensList: _ctx.lensList
          }, null, 8, ["lensList"]))
        : _createCommentVNode("", true),
      (_ctx.selectedTab === 'len')
        ? (_openBlock(), _createBlock(_component_FocalLength, {
            key: 1,
            lensList: _ctx.lensList
          }, null, 8, ["lensList"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}